import { Injectable } from "@angular/core";
import { UploadDocumentModel } from "common/models/page-models/applicants/upload-document/upload-document-data.model";
import { UploadDocumentMetaModel } from "common/models/page-models/applicants/upload-document/upload-document-meta.model";
import { MetaModel } from "common/models/utility-models/base-model";
import { SystemService } from "common/services/core-services/system.service";
import { FormWidgetService } from "../form-widget.service";
import { UploadDocumentDataService } from "common/services/data-services/admin/applicants-dashboard/upload-document-data.service";

@Injectable({
    providedIn: 'root'
  })
  export class UploadDocumentWidgetService extends FormWidgetService<UploadDocumentModel> {
    constructor(
      protected ds: UploadDocumentDataService,
      protected systemService: SystemService
    ) {
      super(ds);
    }

  
    getMetaModel(): MetaModel {
      const meta = new UploadDocumentMetaModel().getMetaModel();
      return meta;
    }
  }
  